module.exports = __webpack_public_path__ + "media/images/svg/map-57b0863d7a5f09e2c90d899d695dc98e.svg";